import compusult from '../../assets/images/compusult.png';
import monarch from '../../assets/images/monarch.png';
import trc from '../../assets/images/trc.png';
import wood from '../../assets/images/wood.svg';
import pennecon from '../../assets/images/pennecon.webp';
import ccore from '../../assets/images/ccore.png';
export type Coords = { lat: number, lon: number };
export type Job = {
    start: Date;
    end: Date;
    title: string;
    company: string;
    addresses: {
        street: string;
        city: string;
        region: string;
        country: string;
        coords: Coords;
    }[];
    role: string[];
    logoImg: any;
    };

export const jobs: Job[] = [
    {
        start: new Date(2022, 0), // January 2022
        end: new Date(), // Current
        title: "Senior Engineering Lead",
        company: "Compusult Ltd",
        addresses: [{
            street: "Bezuidenhoutseweg 161",
            city: "Den Haag",
            region: "South Holland",
            country: "Nederland",
            coords: { lat: 52.086794800155054, lon: 4.333389224142599}
        },
        {
            street: "1522 Dresden Row",
            city: "Halifax",
            region: "Nova Scotia",
            country: "Canada",
            coords:{lat:44.643355821550514, lon: -63.57832589971842}
        },
        {
            street: "40 Bannister Street",
            city: "Mount Pearl",
            region: "Newfoundland And Labrador",
            country: "Canada",
            coords:{lat:47.518480465950894, lon:-52.804683731568545}
        }],
        role: [
            "Defined project scope, gathered requirements and managed milestones to complete projects on-time and under budget.",
            "Presented proposals with focused solutions using scientific knowledge and technology.",
            "Developed detailed project plans.",
            "Attended and presented at various geospatial conferences.",
            "Wrote complex programs and libraries using systems level languages.",
            "Wrote Java bindings for in-house and third-party libraries for use with legacy code.",
            "Communications interfacing between microservices and language interoperability.",
            "Developed web-based 3D geospatial rendering using WebAssembly and WebGL for efficient 3D web streaming.",
            "Developed Dev tooling to increase overall office efficiency and morale.",
        ],
        logoImg: compusult,
    },
    {
        start: new Date(2020, 0), // January 2020
        end: new Date(2022, 0), // January 2022
        title: "President",
        company: "Monarch Performance Engineering Ltd",
        addresses: [{
            street: "",
            city: "",
            region: "Conception Bay South",
            country: "Canada",
            coords: {lat:47.506912269555876, lon:-52.99548078446836}
        }],
        role: [
            "Expanded business operations with a forward-thinking approach based on current market data and forecasts.",
            "Represented organization at industry events, conferences, and meetings.",
            "Identified new business opportunities through market research.",
            "Monitored resource utilization and enacted plans to improve inefficiencies and successfully manage expenses.",
            "Cemented professional development path for staff and managers, giving clear strategies to advance.",
            "Kept operations in line with strategic plans and vision, liaising between board and senior executives to implement policy updates.",
        ],
        logoImg: monarch,
    },
    {
        start: new Date(2017, 0), // January 2017
        end: new Date(2018, 0), // January 2018
        title: "Research Engineer",
        company: "C-Core",
        addresses: [{
            street: "1 Morrissey Road",
            city: "St. John's",
            region: "Newfoundland And Labrador",
            country: "Canada",
            coords: {lat: 47.5756912631995, lon:-52.73491331622621}
        }],
        role: [
            "Carried out R&D with empirical ice morphology experiments.",
            "Developed statistical models of machine/computer vision entities.",
            "Optimized drone and image processing parameters.",
            "Developed methods to reduce the cost and risk of ice thickness determination by several orders of magnitude.",
        ],
        logoImg:ccore,
    },
    {
        start: new Date(2016, 0), // January 2016
        end: new Date(2017, 0), // January 2017
        title: "Computer Engineer",
        company: "Compusult Ltd",
        addresses: [{
            street: "40 Bannister Street",
            city: "Mount Pearl",
            region: "Newfoundland And Labrador",
            country: "Canada",
            coords:{lat:47.518480465950894, lon:-52.804683731568545}
        }],
        role: [
            "Designed and fabricated hardware for sensor applications.",
            "Wrote and troubleshot code.",
            "Integrated existing technologies into innovative new hardware.",
        ],
        logoImg:compusult,
    },
    {
        start: new Date(2015, 0), // January 2015
        end: new Date(2016, 0), // January 2016
        title: "Piping Engineer",
        company: "Wood PLC (formerly WoodGroup PSN)",
        addresses: [{
            street: "277 Water Street",
            city: "St. John's",
            region: "Newfoundland And Labrador",
            country: "Canada",
            coords:{ lat:47.56236119557222, lon:-52.70835638247285}
        }],
        role: [
            "Designed pipes for optimal flow.",
            "Ensured design accuracy and fitment.",
            "Performed flow rate analysis on various systems.",
        ],
        logoImg:wood,
    },
    {
        start: new Date(2013, 0), // January 2013
        end: new Date(2013, 9), // January 2013
        title: "Inside Sales & Rental Coordinator / Hydraulic Technician",
        company: "Pennecon Energy Hydraulic Systems Ltd",
        addresses: [{
            street: "2 Maverick Place",
            city: "Paradise",
            region: "Newfoundland And Labrador",
            country: "Canada",
            coords: {lat: 47.51881597392789, lon:-52.87249184506361}
        }],
        role: [
            "Selected and sourced domestic and foreign parts.",
            "Tested and certified hydraulic tools and equipment.",
        ],
        logoImg:pennecon,
    },
    {
        start: new Date(2012, 0), // January 2012
        end: new Date(2013, 0), // January 2013
        title: "Inside Sales & Assembly / Hydraulic Technician",
        company: "TRC Hydraulics Ltd",
        addresses: [{
            street: "13 Pollard Avenue",
            city: "Paradise",
            region: "Newfoundland And Labrador",
            country: "Canada",
            coords: {lat:47.52067208930405, lon:-52.86084737389831}
        }],
        role: [
            "Fabricated and assembled hydraulic/mechanical equipment.",
            "Field repaired and maintained engines and hydraulic systems.",
        ],
        logoImg:trc,
    },
];
